import {
  GET_FOLDERS_SUCCESS,
  GET_FOLDERS_FAIL,
  CREATE_FOLDER_SUCCESS,
  CREATE_FOLDER_FAIL,
  GET_FOLDER_FILES_SUCCESS,
  GET_FOLDER_FILES_FAIL,
  ADD_FILE_TO_FOLDER_SUCCESS,
  ADD_FILE_TO_FOLDER_FAIL,
  GET_FOLDER_FILES,
  DELETE_FOLDER_FILES_SUCCESS,
  DELETE_FOLDER_FILES_FAIL,
  ASSIGN_FOLDERS_SUCCESS,
  ASSIGN_FOLDERS_FAIL,
  GET_ASSIGNED_MEMBERS_SUCCESS,
  GET_ASSIGNED_MEMBERS_FAIL,
  REMOVE_FOLDER_USER_SUCCESS,
  REMOVE_FOLDER_USER_FAIL,
  UPDATE_FOLDER_PERMISSION_SUCCESS,
  UPDATE_FOLDER_PERMISSION_FAIL,
  GET_FOLDERS,
  DELETE_FOLDER_SUCCESS,
  DELETE_FOLDER_FAIL,
  RENAME_FOLDER_SUCCESS,
  RENAME_FOLDER_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  folders: [],
  files: [],
  error: [],
  res: [],
  loading: false,
  assignedList: [],
  updateRes: [],
};

const FileManager = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RENAME_FOLDER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case RENAME_FOLDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_FOLDER_PERMISSION_SUCCESS:
      return {
        ...state,
        updateRes: action.payload,
      };

    case UPDATE_FOLDER_PERMISSION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REMOVE_FOLDER_USER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case REMOVE_FOLDER_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ASSIGNED_MEMBERS_SUCCESS:
      return {
        ...state,
        assignedList: action.payload,
      };

    case GET_ASSIGNED_MEMBERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ASSIGN_FOLDERS_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case ASSIGN_FOLDERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_FILE_TO_FOLDER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case ADD_FILE_TO_FOLDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_FOLDER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case DELETE_FOLDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_FOLDER_FILES_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case DELETE_FOLDER_FILES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_FOLDER_FILES:
      return {
        ...state,
        loading: true,
      };
    case GET_FOLDER_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        files: action.payload,
      };

    case GET_FOLDER_FILES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREATE_FOLDER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case CREATE_FOLDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_FOLDERS:
      return {
        ...state,
        loading: true,
      };
    case GET_FOLDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        folders: action.payload,
      };

    case GET_FOLDERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default FileManager;
